import { RetencionDetalle } from "./retencion_detalle";
import { Venta } from "./venta";
import { Compra } from "./compra";
import { Caja } from "./caja";
import { AsientoContable } from "./asiento-contable";

export class Retencion{
    public constructor(
        public id: String = "",
        public tipo: String = "",
        public tipo_comprobante_id: number = 0,
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public is_secuencial_manual: boolean = false,
        public numero_documento: String = "",
        public fecha_caducidad: String = "",
        public fecha_emision: String = "",
        public numero_autorizacion: String = "",
        
        public total_renta: number = 0,
        public total_iva: number = 0,
        public total: number = 0,
        public observacion: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public documento_id: String = "",
        public caja_id: String = "",
        public usuario_id:String = null,
        public detalle: Array<RetencionDetalle> = [],
        public json_string: any = {},
        public status: String = "",
        
        //
        public venta: any = {}, //new Venta(),
        public compra: any = {}, //new Compra(),
        public caja: Caja = new Caja(),
        public estadobitacora: any = {},
        public tipocomprobante: any = {},

        public asientosContables: Array<AsientoContable> = [],
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/retencion.ts